import { EntityState } from '@ngrx/entity';
import { ICostCenter } from './medlogic/icost-center';
export interface ICostCenterState extends EntityState<ICostCenter>  {
  error: any;
  selectedId: number | null;
}
